import ENV from "../config/env";
import tMobileServiceApi from "./tMobileService-api";

class TMobileService {
    getAllDevices = (limit:number) => {
      const url = `/device1?limit=${limit}`;
      return tMobileServiceApi.get(url);
    };
}

export default new TMobileService()